import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { MultiLanApiResponse } from '../../types/api/multiLanguageApi';
import { getMultiLanguageDataService } from '../../api/multiLanguageJson';
import { IMultiLanState } from '../../types/features/multiLanguageSlice';




export const getMultiLanguageData = createAsyncThunk<MultiLanApiResponse>(
    'multiLanguage/getMultiLanguageData',
    async () => {
        const response = await getMultiLanguageDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const multiLanguageAccessSlice = createSlice({
    name: 'multiLanguage',
    initialState: {
       
        multiLanguage: [],
       multiLanguageLoader:true,
        status: false,
        msg: ''
    } as IMultiLanState, 
    reducers: {
        resetLoader(state) {
            state.multiLanguageLoader = false;
            state.msg = "";
          },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMultiLanguageData.pending, (state) => {
                state.multiLanguageLoader = true;
            })
            .addCase(getMultiLanguageData.fulfilled, (state, action: PayloadAction<MultiLanApiResponse>) => {
                state.multiLanguage = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                // state.multiLanguageLoader = false;
            })
            .addCase(getMultiLanguageData.rejected, (state, action) => {
                state.multiLanguageLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
     
    }
});
export const { resetLoader } = multiLanguageAccessSlice.actions;

export default multiLanguageAccessSlice.reducer;
